import { render, staticRenderFns } from "./ApplicationTab.vue?vue&type=template&id=28770efc&scoped=true&"
import script from "./ApplicationTab.vue?vue&type=script&lang=js&"
export * from "./ApplicationTab.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationTab.vue?vue&type=style&index=0&id=28770efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28770efc",
  null
  
)

export default component.exports